<template>
  <div v-if="isOpen" :class="$style.modal">
    <div :class="$style.overlay" @click="$emit('close')"></div>
    <div :class="$style.content" @click.stop>
      <div :class="$style.top">
        <div :class="$style.close" @click.stop="$emit('close')">
          <img src="/icons/common/cross-black.svg" alt="" />
        </div>
        Подтверждение удаления
      </div>
      <div :class="$style.body">
        <div :class="$style.iconBox">
          <div :class="$style.icon">
            <img src="/icons/common/warning-circle.svg" alt="" />
          </div>
        </div>
        <div :class="$style.message">
          Вы уверены, что хотите удалить неподтвержденные элементы?
        </div>
        <div :class="$style.count">
          <div :class="$style.label">Будет удалено элементов:</div>
          <div :class="$style.value">{{ count }}</div>
        </div>
      </div>
      <div :class="$style.footer">
        <div :class="$style.cancel" @click="$emit('close')">Отмена</div>
        <div :class="$style.confirm" @click="$emit('confirm')">Удалить</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeleteConfirmModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  emits: ["close", "confirm"],
};
</script>

<style lang="scss" module>
$bg-light: rgba(248, 250, 250, 1);
$bg-dark: rgba(230, 232, 232, 1);
$red-light: rgba(255, 59, 48, 0.1);
@keyframes expand {
  from {
    transform: scale(0.7);
    opacity: 0;
  }
}
.modal {
  position: fixed;
  inset: 0;
  z-index: 70;
  .overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(1.25rem);
    animation: expand 0.2s ease-in-out;
  }
  .content {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 32rem;
    max-height: calc(100vh - 4rem);
    overflow: auto;
    background-color: $bg-white;
    border-radius: 2rem;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    animation: expand 0.2s ease-in-out;
    @include scrollbarY;
    .top {
      position: relative;
      padding: 1.5rem 1.5rem 0;
      text-align: center;
      font-size: 1.25rem;
      font-weight: 700;
      color: $black;
      .close {
        position: absolute;
        right: 0;
        top: 0;
        img {
          padding: 1rem;
          cursor: pointer;
          transition: opacity 0.2s;
          &:hover {
            opacity: 0.7;
          }
        }
      }
    }
    .body {
      padding: 2rem 1.5rem;
      text-align: center;
      .iconBox {
        display: flex;
        justify-content: center;
        margin-bottom: 1.5rem;
        .icon {
          width: 4rem;
          height: 4rem;
          border-radius: 50%;
          background-color: $red-light;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 2rem;
            height: 2rem;
            filter: brightness(0) saturate(100%) invert(27%) sepia(95%)
              saturate(7471%) hue-rotate(349deg) brightness(99%) contrast(101%);
          }
        }
      }
      .message {
        margin-bottom: 1.5rem;
        font-size: 1rem;
        line-height: 1.6;
        color: $black;
        font-weight: 500;
      }
      .count {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.5rem;
        padding: 1rem;
        background-color: $bg-dark;
        border-radius: 0.75rem;
        .label {
          font-size: 0.875rem;
          color: $t-secondary;
          font-weight: 400;
        }
        .value {
          font-size: 2rem;
          font-weight: 700;
          color: $red;
          line-height: 1;
        }
      }
    }
    .footer {
      padding: 1.5rem;
      border-top: 1px solid $bg-light;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.75rem;
      .cancel,
      .confirm {
        padding: 0.75rem 2rem;
        border-radius: 0.5rem;
        font-weight: 600;
        font-size: 0.875rem;
        cursor: pointer;
        transition: all 0.2s;
        min-width: 6rem;
        text-align: center;
        &:active {
          transform: scale(0.98);
        }
      }
      .cancel {
        background-color: $black;
        color: $t-white;
        border: none;
        &:hover {
          background-color: darken($black, 8%);
        }
      }
      .confirm {
        background-color: $red;
        color: $t-white;
        border: none;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        &:hover {
          background-color: darken($red, 8%);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
        }
        &:active {
          background-color: darken($red, 12%);
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
}
</style>

